import React, { useEffect, useState } from 'lib/react';
import { makeStyles, EVButton } from 'lib/components';
import { useDispatch, useSelector } from 'lib/redux';
import Typography from 'commonComponents/typography';
import { useTranslation } from 'lib/translation';
import { fetchReportAnalytics } from 'features/analyticsDashboard/AnalyticsDashboard.actions';

const useStyles = makeStyles((theme) => ({
  refreshButton: {
    padding: 0,
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 400,
    color: theme.evPalette.ocean[600],
    textDecoration: 'underline',
  },
}));

function LastUpdatedTime() {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const reportAnalyticsFetchedTime = useSelector(({ analyticsDashboard }) => analyticsDashboard.successTimestamp.reportAnalytics);

  const [fetchedMinutesAgo, setFetchedMinutesAgo] = useState(
    reportAnalyticsFetchedTime ? Math.floor((Date.now() - reportAnalyticsFetchedTime) / 60000) : null,
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setFetchedMinutesAgo(Math.floor((Date.now() - reportAnalyticsFetchedTime) / 60000));
    }, 60000);

    return () => clearInterval(interval);
  }, [reportAnalyticsFetchedTime]);

  const handleRefresh = () => dispatch(fetchReportAnalytics({ refreshData: true }));

  return (fetchedMinutesAgo !== null) && (
  <Typography component="span" variant="label-400" fontColor="charcoal-700">
    {t('analytics_dashboard__updated_mins_ago', { minutes: fetchedMinutesAgo })}
    <EVButton
      id="refresh-data-button"
      className={classes.refreshButton}
      onClick={handleRefresh}
    >
      {t('common__refresh')}
    </EVButton>
  </Typography>
  );
}

export default LastUpdatedTime;
